var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 20,
    height: 20,
    transform: "translate(4.291 4.29)",
    fill: "#012169",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(-4.291 -4.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_640",
    "data-name": "Mask Group 640",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "google_podcast_icon_135536",
    d: "M17.68,7.22v1.4a1.25,1.25,0,0,1-2.5,0V7.22a1.25,1.25,0,0,1,2.5,0M13.25,8.36v7.27a1.25,1.25,0,0,1-2.5,0V8.36a1.25,1.25,0,0,1,2.5,0M22,11.3v1.4a1.25,1.25,0,0,1-2.5,0V11.3a1.25,1.25,0,0,1,2.5,0m-17.5,0v1.4a1.25,1.25,0,0,1-2.5,0V11.3a1.25,1.25,0,0,1,2.5,0m4.32,4.08v1.39a1.25,1.25,0,0,1-2.5,0V15.38a1.25,1.25,0,0,1,2.5,0m4.43,3.98v1.39a1.25,1.25,0,0,1-2.5,0V19.36a1.25,1.25,0,0,1,2.5,0m0-16.11V4.64a1.25,1.25,0,0,1-2.5,0V3.25a1.25,1.25,0,1,1,2.5,0m4.43,9.09v4.43a1.25,1.25,0,0,1-2.5,0V12.34a1.25,1.25,0,0,1,2.5,0M8.82,7.22v4.43a1.25,1.25,0,1,1-2.5,0V7.22a1.25,1.25,0,0,1,2.5,0Z",
    transform: "translate(2.291 2.29)",
    fill: "#012169"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share2.c56fa067982d672f1fe7650300ee6df2.svg";
export { ForwardRef as ReactComponent };